import { resolveComponent, createElementBlock, openBlock, createCommentVNode, createElementVNode, unref, toDisplayString, renderSlot, normalizeClass, createVNode, withCtx, createBlock } from "vue";
import { useDisplay } from "vuetify";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import { useRouter } from "../../plugins/router.js";
import "maska";
import { useLocalePath } from "../../composables/useLocalePath.js";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vue-router";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import { VCard, VCardText, VCardActions } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import { VSpacer } from "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                            */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                 */
import { ENTITY_RECORD_PROPS } from "../../composables/useEntityRecord.js";
import { ENTITY_CARD_PROPS, useEntityCard } from "../../composables/useEntityCard.js";
/* empty css              */
import "vuetify/components";
/* empty css                    */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
const _hoisted_1 = { class: "b-edit-card" };
const _hoisted_2 = {
  key: 0,
  class: "b-edit-card__header d-flex flex-wrap justify-space-between align-center mb-8 g-2"
};
const _hoisted_3 = {
  key: 0,
  class: "b-edit-card__header-title"
};
const _hoisted_4 = {
  key: 1,
  class: "b-edit-card__header-actions d-flex align-center g-2"
};
const _sfc_main = {
  __name: "BaseCard",
  props: {
    // --- Entity Record Composable Props ---
    ...ENTITY_RECORD_PROPS,
    ...ENTITY_CARD_PROPS,
    // --- Card Props ---
    sectionPath: {
      type: String
    },
    closeOnCreate: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, { expose: __expose }) {
    const { mdAndUp } = useDisplay();
    const router = useRouter();
    const localePath = useLocalePath();
    const props = __props;
    const { item, isNew, header, showActions, validate, save, onSaved, reset } = useEntityCard(props);
    const close = () => props.sectionPath ? router.push(localePath(props.sectionPath)) : router.back();
    onSaved(({ isNew: isNew2 }) => {
      if (isNew2 && props.closeOnCreate) {
        close();
      }
    });
    __expose({
      item,
      validate,
      save,
      reset
    });
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock("div", _hoisted_1, [
        unref(header) || _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", _hoisted_2, [
          unref(header) ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(unref(header)), 1)) : createCommentVNode("", true),
          _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", _hoisted_4, [
            renderSlot(_ctx.$slots, "header-actions", {
              item: unref(item),
              isNew: unref(isNew)
            })
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass([
            "b-edit-card__wrapper",
            unref(mdAndUp) ? "g-12" : "g-6 flex-column"
          ])
        }, [
          createVNode(VCard, {
            class: normalizeClass([
              "b-edit-card__form",
              {
                "no-actions": !unref(showActions)
              }
            ]),
            rounded: "xl",
            flat: ""
          }, {
            default: withCtx(() => [
              !_ctx.hideActions ? (openBlock(), createBlock(_component_b_btn, {
                key: 0,
                class: "close-button",
                preset: "closeMini",
                size: 40,
                "icon-size": 24,
                onClick: close
              })) : createCommentVNode("", true),
              createVNode(VCardText, { class: "b-edit-card__content pa-0" }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default", {
                    item: unref(item),
                    isNew: unref(isNew)
                  })
                ]),
                _: 3
              }),
              createVNode(VSpacer),
              unref(showActions) ? (openBlock(), createBlock(VCardActions, {
                key: 1,
                class: "g-4 mt-8 mx-auto mr-lg-0 px-4 pr-0"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "actions", {}, () => [
                    createVNode(_component_b_btn, {
                      class: "b-edit-card__form__button",
                      preset: "cancel",
                      text: _ctx.$t("base.buttons.reset"),
                      onClick: unref(reset)
                    }, null, 8, ["text", "onClick"]),
                    createVNode(_component_b_btn, {
                      class: "b-edit-card__form__button",
                      preset: "save",
                      onClick: unref(save)
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 3
              })) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["class"])
        ], 2)
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
